import { AdditiveBlending, Color, ShaderMaterial, Vector3 } from 'three';

import vertexShader from './globalShockMaterialVertex.glsl';
import fragmentShader from './globalShockMaterialFragment.glsl';
import AppEngine from '../general/appEngine';

const yAxis = new Vector3(0, 1, 0);

export default class GlobalImpactMaterial extends ShaderMaterial {
  constructor() {
    const uniforms = {
      color: { value: new Color(0xff0050).multiplyScalar(0.8 * AppEngine.HDR_SCALE) },
      phase: { value: 0.0 },
      direction: { value: new Vector3() },
      directionX: { value: new Vector3() },
      directionY: { value: new Vector3() },
      radius: { value: 0.5 },
      width: { value: 0.0025 },
      width2: { value: 0.15 },
      falloff: { value: 2 },
      noiseMap: { value: null },
      normalMap: { value: null },
      sdf: { value: null },
      distortionNoise: { value: 0.1 },
      distortionNormal: { value: 0.3 },
      noiseScale: { value: 2.0 },
      layerBlend: { value: 0.7 },
    };

    super({
      uniforms,
      vertexShader,
      fragmentShader,
      depthWrite: false,
      transparent: true,
      blending: AdditiveBlending,
    });

    this.direction = new Vector3(-3, 1, -1);
    this._phase = 0;
    this._width2 = this.uniforms.width2.value;
  }

  get noiseMap() {
    return this.uniforms.noiseMap.value;
  }

  set noiseMap(value) {
    this.uniforms.noiseMap.value = value;
  }

  get sdf() {
    return this.uniforms.sdf.value;
  }

  set sdf(value) {
    this.uniforms.sdf.value = value;
  }

  get normalMap() {
    return this.uniforms.normalMap.value;
  }

  set normalMap(value) {
    this.uniforms.normalMap.value = value;
  }

  get direction() {
    return this.uniforms.direction.value;
  }

  set direction(value) {
    const x = this.uniforms.directionX.value;
    const y = this.uniforms.directionY.value;
    const z = this.uniforms.direction.value;
    z.copy(value).normalize();
    x.crossVectors(yAxis, z).normalize();
    y.crossVectors(z, x).normalize();
  }

  get phase() {
    return this._phase;
  }

  set phase(value) {
    this._phase = value;
    // normalize
    this.uniforms.phase.value = value / (1.0 + 2.0 * this._width2) - this._width2;
  }

  get radius() {
    return this.uniforms.radius.value;
  }

  set radius(value) {
    this.uniforms.radius.value = value;
  }
}
